var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SkeletonLoader,{staticClass:"tab-list__tabs"},_vm._l((3),function(index){return _c('div',{key:index,staticClass:"tab-list__tab"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }